import { NgComponentOutlet } from "@angular/common";
import { Component } from "@angular/core";
import { Button } from "@ankaadia/ankaadia-shared-frontend";
import { DialogModule } from "primeng-v17/dialog";
import { ToggleButtonModule } from "primeng-v17/togglebutton";
import { NewUiChatWidgetDialogComponent } from "./new-ui-chat-widget-dialog.component";

@Component({
  selector: "app-chat-widget-dialog",
  imports: [DialogModule, ToggleButtonModule, Button, NgComponentOutlet],
  templateUrl: "./chat-widget-dialog.component.html",
  styleUrl: "./chat-widget-dialog.component.scss",
})
export class ChatWidgetDialogComponent extends NewUiChatWidgetDialogComponent {}
